export function matchesPath(pattern: string, path: string): boolean {
  // Normalize paths by ensuring they start with '/' and don't have trailing slashes
  // (except for the root path '/')
  const normalizeRoute = (route: string): string => {
    if (route === "" || route === "/") return "/";
    return "/" + route.replace(/^\/+|\/+$/g, "");
  };

  const normalizedPattern = normalizeRoute(pattern);
  const normalizedPath = normalizeRoute(path);

  // Check for exact match
  if (normalizedPattern === normalizedPath) {
    return true;
  }

  // Check for wildcard match
  if (normalizedPattern.endsWith("/*")) {
    const patternBase = normalizedPattern.slice(0, -2);
    // Path must start with the pattern base
    if (normalizedPath === patternBase) {
      return true; // Match when path equals pattern without the '/*'
    }
    return normalizedPath.startsWith(patternBase + "/");
  }

  return false;
}
